module.exports={render:function (){with(this) {
  return _h('div', [_h('div', {
    staticClass: "left"
  }, [_m(0), " ", _h('p', ["\n      You found one! That brings your total up to " + _s(points) + ".\n      ", (points === 1) ? _h('span', ["Keep up the good work to unlock more animals!"]) : _e()]), " ", _h('div', {
    staticClass: "label label--for-checkbox"
  }, [_h('label', [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (expertMode),
      expression: "expertMode"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(expertMode) ? _i(expertMode, null) > -1 : _q(expertMode, true)
    },
    on: {
      "change": function($event) {
        var $$a = expertMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _i($$a, $$v);
          if ($$c) {
            $$i < 0 && (expertMode = $$a.concat($$v))
          } else {
            $$i > -1 && (expertMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          expertMode = $$c
        }
      }
    }
  }), "\n        Expert Mode\n        ", _m(1), " ", _m(2)])]), " ", _h('div', {
    staticClass: "label label--for-select"
  }, [_h('label', ["\n        Find a\n        ", _h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (animal),
      expression: "animal"
    }],
    on: {
      "change": function($event) {
        animal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          return "_value" in o ? o._value : o.value
        })[0]
      }
    }
  }, [_l((unlockedAnimals), function(animal) {
    return _h('option', {
      domProps: {
        "value": animal.key
      }
    }, ["\n            " + _s(animal.name) + "\n          "])
  })])])]), " ", (points < ANIMALS[1].pointsRequired) ? _h('small', {
    staticClass: "tip"
  }, ["\n      Get to ", _m(3), " to unlock another animal\n    "]) : _e(), " ", (points >= ANIMALS[1].pointsRequired && points < ANIMALS[2].pointsRequired) ? _h('small', {
    staticClass: "tip"
  }, ["\n      Get to ", _m(4), " to unlock the final animal\n    "]) : _e(), " ", (points >= ANIMALS[2].pointsRequired) ? _h('small', {
    staticClass: "tip"
  }, ["\n      Congratulations, you’ve unlocked them all!\n    "]) : _e(), " ", _h('find-button', {
    on: {
      "click": function($event) {
        setPage(PAGE_GAME)
      }
    }
  }, ["Find a " + _s(animal)]), " ", _h('find-social-button', {
    attrs: {
      "network": "facebook"
    }
  }), " ", _h('find-social-button', {
    attrs: {
      "network": "twitter"
    }
  })]), " ", _m(5)])
}},staticRenderFns: [function (){with(this) {
  return _h('h1', ["Congratulations"])
}},function (){with(this) {
  return _h('br')
}},function (){with(this) {
  return _h('small', ["(your cursor won't change when you hover over the cow)"])
}},function (){with(this) {
  return _h('strong', ["five points"])
}},function (){with(this) {
  return _h('strong', ["fifty points"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "right"
  }, [_h('ins', {
    staticClass: "adsbygoogle",
    attrs: {
      "style": "width:300px;height:250px",
      "data-ad-client": "ca-pub-3956850377782988",
      "data-ad-slot": "4677943079"
    }
  })])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a11ba68c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Congratulations.vue
 ** module id = 169
 ** module chunks = 2
 **/